var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7186 22.2814C43.4271 23.99 43.4271 26.7601 41.7186 28.4686C40.0101 30.1772 37.2399 30.1772 35.5314 28.4686C33.8229 26.7601 33.8229 23.99 35.5314 22.2814C37.2399 20.5729 40.0101 20.5729 41.7186 22.2814ZM28.5936 22.2814C30.3022 23.99 30.3022 26.7601 28.5936 28.4686C26.8851 30.1772 24.115 30.1772 22.4064 28.4686C20.6979 26.7601 20.6979 23.99 22.4064 22.2814C24.115 20.5729 26.8851 20.5729 28.5936 22.2814ZM15.4686 22.2814C17.1771 23.99 17.1771 26.7601 15.4686 28.4686C13.7601 30.1772 10.9899 30.1772 9.28141 28.4686C7.57286 26.7601 7.57286 23.99 9.28141 22.2814C10.9899 20.5729 13.7601 20.5729 15.4686 22.2814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.bca452178e4cdcd1be4eb89cc47a555a.svg";
export { ForwardRef as ReactComponent };